import { createSelector } from 'reselect';
import { FILTER_KEYS } from './fixtures';

export const getBarcodeItems = ({ barcodeItems }) => barcodeItems.data;

export const getBarcodeItemsLoadingState = ({ barcodeItems }) => barcodeItems.loading;
export const getBarcodeItemsFilters = ({ barcodeItems }) => barcodeItems.filters;
// eslint-disable-next-line max-len
export const getIsBarcodeItemValid = ({ barcodeItemsActions }) => barcodeItemsActions.isValid;
export const getIsBarcodeItemDuplicates = ({ barcodeItemsActions }) => barcodeItemsActions.existingItems;
export const getBarcodeItemValidationState = ({ barcodeItemsActions }) => barcodeItemsActions.isValidating;
export const getBarcodeItemSearchResult = ({ barcodeItemsActions }) => barcodeItemsActions.searchValue;
export const getBarcodeItemSearchResultLoading = ({ barcodeItemsActions }) => barcodeItemsActions.isLoading;
// eslint-disable-next-line max-len

export const getQueryArray = createSelector(
  getBarcodeItemsFilters,
  ({
    [FILTER_KEYS.PAGE]: page,
    [FILTER_KEYS.PER_PAGE]: perPage,
    // [FILTER_KEYS.TYPE]: itemTtpe,
    [FILTER_KEYS.HAS_MORE]: hasMore,
    [FILTER_KEYS.SORT_DIRECTION]: sortDirection,
    ...queryParams
    // eslint-disable-next-line no-shadow,max-len
  }) => Object.keys(queryParams).reduce((result, type) => {
    switch (type) {
    // case FILTER_KEYS.QUANTITY: {
    //   const isAnyQtyAllowed = queryParams[type] !== null;
    //   if (isAnyQtyAllowed) {
    //     return [
    //       ...result,
    //       {
    //         type,
    //         value: null,
    //         text: 'None',
    //       },
    //     ];
    //   }
    //
    //   return result;
    // }
    case FILTER_KEYS.QUERY: {
      // const isEmpty = queryParams[type].length === 0;
      const query = queryParams[type];

      if(query) {
        return [
          ...result,
          {
            type,
            value: query,
            text: query,
          },
        ];
      }

      return result;
    }

    default: {
      return result;
    }
    }
  }, []),
);

export const getBarcodeItemsFormattedFilters = createSelector(
  getBarcodeItemsFilters,
  (filters) => ({
    ...filters,
    // [FILTER_KEYS.TAGS]: filters[FILTER_KEYS.TAGS].map(({ id }) => id),
    // [FILTER_KEYS.ITEMS]: filters[FILTER_KEYS.ITEMS].map(({ id }) => id),
  }),
);
